import {
  FETCH_ATTENDANCE_INIT,
  EDIT_ATTENDANCE,
  FETCH_HISTORIC,
  FETCH_ITEM_HISTORIC,
  FETCH_ITEM_BY_BARCODE,
  FETCH_COMMISSIONED_PERSONS,
  FETCH_ATTENDANCE_HISTORY,
  FETCH_NFSE_COMPANIES,
  FETCH_DOCUMENT_CONTEXTS,
} from './AttendanceActions'

const INITIAL_STATE = {
  items: [],
  totalSize: 0,
  page: 1,
  sizePerPage: 10,
  filters: {},
  editingAttendance: null,
  comoConheci: [],
  status: [],
  services: [],
  paymentMethods: [],
  attendants: [],
  historic: [],
  itemHistoric: [],
  itemByBarcode: { documents: [], itemStatus: [] },
  attendanceHistory: [],
  companies: [],
  itemStatuses: [],
  banks: [],
  suppliers: [],
  commissionedPersons: [],
  archiveReason: [],
  recurrenceTrigger: {},
  nfseCompanies: [],
  documentContexts: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ATTENDANCE_INIT.SUCCESS:
      return {
        ...state,
        items: action.payload.data.data,
        comoConheci: action.payload.data.comoConheci,
        status: action.payload.data.status,
        services: action.payload.data.services,
        totalSize: action.payload.data.meta.total,
        page: action.payload.data.meta.current_page,
        sizePerPage: action.payload.data.meta.per_page,
        paymentMethods: action.payload.data.paymentMethods,
        attendants: action.payload.data.attendants,
        companies: action.payload.data.companies,
        itemStatuses: action.payload.data.itemStatuses,
        banks: action.payload.data.banks,
        filters: action.payload.filters,
        suppliers: action.payload.data.suppliers,
        archiveReason: action.payload.data.archiveReason,
        recurrenceTrigger: action.payload.data.recurrenceTrigger,
      }
    case FETCH_DOCUMENT_CONTEXTS.SUCCESS:
      return {
        ...state,
        documentContexts: action.payload.data,
      }
    case FETCH_COMMISSIONED_PERSONS.SUCCESS:
      return {
        ...state,
        commissionedPersons: action.payload.data,
      }
    case EDIT_ATTENDANCE.SUCCESS:
      return {
        ...state,
        editingAttendance: {
          ...action.payload.data,
          final_value_discount: action.payload.data.total_with_discount,
          services: action.payload.data.services.map(_item => {
            let item = { ..._item }
            if (item?.measureType.id === 1)
              item = { ...item, quantity: parseInt(item.quantity, 10) }
            return item
          }),
        },
      }
    case 'SAVE_FILTERS':
      return {
        ...state,
        filters: action.payload,
      }
    case 'ERASE_FILTERS':
      return {
        ...state,
        filters: {},
      }
    case FETCH_HISTORIC.SUCCESS:
      return {
        ...state,
        historic: action.payload.data,
      }
    case FETCH_ITEM_HISTORIC.SUCCESS:
      return {
        ...state,
        itemHistoric: action.payload.data,
      }
    case FETCH_ITEM_BY_BARCODE.SUCCESS:
      return {
        ...state,
        itemByBarcode: action.payload.data,
      }
    case FETCH_ATTENDANCE_HISTORY.SUCCESS:
      return {
        ...state,
        attendanceHistory: action.payload.data,
      }
    case FETCH_NFSE_COMPANIES.SUCCESS:
      return {
        ...state,
        nfseCompanies: action.payload.data,
      }
    default:
      return state
  }
}

export const getAttendanceListData = state => {
  return {
    items: state.attendance.items,
    page: state.attendance.page,
    sizePerPage: state.attendance.sizePerPage,
    totalSize: state.attendance.totalSize,
  }
}

export const getEditingAttendance = state => {
  return state.attendance.editingAttendance
}
